import { StorageKeys } from '@constants/storageKeys';
import { atom } from 'jotai';
import { createStorageKey } from '@utils/storage';
import { stringAtomWithLocalStorage } from '@utils/atomWithLocalStorage';
import { atomWithStorage } from 'jotai/utils';
import { DEFAULT_DOC_CLASS } from '@routing/appUrls';

export const currentDocClassAtom = stringAtomWithLocalStorage(createStorageKey([StorageKeys.CurrentDocClass]), DEFAULT_DOC_CLASS);
export const reuseTargetWindowAtom = atomWithStorage(createStorageKey([StorageKeys.ReuseTargetWindow]), false);
export const disableUserSelectionAtom = atom<boolean>(false);

export const firstDocumentAtom = atom<number | null>(null);
